var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Stack } from 'syf-component-library/ui/spacing';
import query from 'syf-component-library/const/mediaQueries';
import { ModalType } from '../../../redux/ui/typings';
import { SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal } from '../../../redux/ui/ui.slice';
import { triggerAnalyticsEvent } from 'syf-js-utilities';
import { Analytics } from '../../../helpers/analyticsMiddleware';
import { t } from '../../../strings/i18n/i18n';
import { updateAppConfig } from '../../../redux/appConfig/appConfig.slice';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import ModalHeaderStrip from '../../../ui/atoms/ModalHeaderStrip';
import isNotCompletedOrCanceled from '../../../helpers/isNotCompletedOrCanceled';
import LaunchPointName from '../../../const/launchPointName';
import useDDPreventScroll from '../../../hooks/useDDPreventScrolling';
import useSelectedDispute from '../../../hooks/useSelectedDispute';
import DisputeModalHeader from '../../../ui/organisms/DisputeModalHeader';
import DisputeInfoHeaderContent from '../../../ui/organisms/DisputeInfoHeaderContent';
import DisputeInfoModalFooter from '../../../ui/organisms/DisputeInfoModalFooter';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import SLIDE_IN_MODAL_CONTAINER_ID from '../../../const/modalContainerIds';
import { TransactionStatus } from '../../../const/transactionStatus';
import { updateRedispute } from '../../../redux/questionnaire/questionnaire.slice';
import { updateTransactionData } from '../../../redux/transactionData/transactionData.slice';
import DisputeTracker from './DisputeTracker';
import getDisputeInfoPageName from './helpers';
import DocumentsRequested from './DocumentsRequested';
import DisputeDetails from './DisputeDetails';
import DisputeInfoTabs from './DisputeInfoTabs';
var ELIGIBLE_FOR_UPLOADS = [
    TransactionStatus.SET_1,
    TransactionStatus.SET_2,
    TransactionStatus.SET_3,
    TransactionStatus.SET_4,
    TransactionStatus.SET_22,
    TransactionStatus.SET_23
];
var ELIGIBLE_FOR_REDISPUTE = [
    TransactionStatus.SET_8,
    TransactionStatus.SET_14,
    TransactionStatus.SET_15,
    TransactionStatus.SET_16,
    TransactionStatus.SET_17,
    TransactionStatus.SET_18,
    TransactionStatus.SET_20
];
var ModalContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: ", "px;\n"], ["\n  padding-bottom: ", "px;\n"])), spacing.xlarge);
var DisputeInfoUpperSection = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  @media ", " {\n    padding-left: 56px;\n    padding-right: 56px;\n  }\n"], ["\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  @media ", " {\n    padding-left: 56px;\n    padding-right: 56px;\n  }\n"])), spacing.large, spacing.large, query.greaterThanMedium);
var DisputeInfoLowerSection = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  @media ", " {\n    padding-left: ", "px;\n    padding-right: ", "px;\n  }\n"], ["\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  @media ", " {\n    padding-left: ", "px;\n    padding-right: ", "px;\n  }\n"])), spacing.base, spacing.base, query.greaterThanMedium, spacing.xlarge, spacing.xlarge);
var DisputeInfo = function () {
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state; }, shallowEqual), appConfig = _a.appConfig, assetsURL = _a.mfeConfig.assetsURL, _b = _a.featureFlags, docsRequested = _b.docsRequested, disputeTabs = _b.disputeTabs;
    var additionalInfoEnabled = useSelector(function (_a) {
        var featureFlags = _a.featureFlags;
        return featureFlags;
    }).additionalInfo;
    var _c = useSelectedDispute(), selectedDisputeDetails = _c.selectedDispute, selectedTransaction = _c.selectedTransaction;
    useDDPreventScroll();
    var amountInDispute = selectedTransaction.amountInDispute, merchantName = selectedTransaction.merchantName, transactionId = selectedTransaction.id, transactionStatus = selectedTransaction.statusCode, disputeReason = selectedTransaction.disputeReason, statusDescription = selectedTransaction.statusDescription, redisputeCount = selectedTransaction.reDisputeCount, transactionDate = selectedTransaction.transactionDate;
    var eligibleForRedispute = ELIGIBLE_FOR_REDISPUTE.includes(transactionStatus) && redisputeCount === 0;
    var accountId = appConfig.accountId;
    var eligibleForUploads = ELIGIBLE_FOR_UPLOADS.includes(transactionStatus);
    var eligibleForCancel = isNotCompletedOrCanceled(transactionStatus);
    /* istanbul ignore next */
    var fireCloseModal = function () {
        dispatch(closeModal());
    };
    var handleLaunchChat = function () {
        dispatch(closeModal());
        pointOfNeedChat(LaunchPointName.UploadDocs, accountId);
    };
    var handleUploadDocuments = function () {
        dispatch(updateAppConfig(__assign(__assign({}, appConfig), { selectedDispute: __assign({ transactionId: transactionId }, selectedDisputeDetails) })));
        dispatch(openModal(ModalType.AdditionalInfo));
    };
    var onCancelDispute = function () {
        dispatch(updateAppConfig(__assign(__assign({}, appConfig), { selectedDispute: __assign(__assign({}, selectedDisputeDetails), { transactionId: transactionId }) })));
        dispatch(openModal(ModalType.CancelDispute));
    };
    var handleRedispute = function () {
        dispatch(closeModal());
        dispatch(updateRedispute(true));
        dispatch(updateTransactionData({
            transactionId: transactionId,
            referenceNumber: '',
            transactionCode: '',
            transactionDate: transactionDate,
            transactionAmount: amountInDispute,
            merchantName: merchantName,
            merchantDesc: merchantName
        }));
        dispatch(openModal(ModalType.Questionnaire));
    };
    useEffect(function () {
        var pageAttributes = getDisputeInfoPageName(transactionStatus);
        triggerAnalyticsEvent(__assign({ PageKind: Analytics.Dispute, pageFunction: Analytics.Status, message: disputeReason }, pageAttributes));
        return function () {
            triggerAnalyticsEvent(__assign(__assign({}, pageAttributes), { pageKind: Analytics.Activity, pageFunction: Analytics.DisputeTransaction, pageSubFunction: '', pageName: Analytics.View, message: '' }));
        };
    }, [disputeReason, statusDescription, transactionStatus]);
    return (_jsxs(SlideInModalPortal, __assign({ "aria-label": "Disputes Details", id: "modal", containerId: SLIDE_IN_MODAL_CONTAINER_ID, isOpen: true, escapeModalHandler: fireCloseModal, header: _jsx(DisputeModalHeader, { closeModal: fireCloseModal, content: t('disputeInfo.title'), "data-object": "button", dataReason: "close", dataTitle: "dispute-transaction", dataType: "dispute-transaction" }), footer: _jsx(DisputeInfoModalFooter, { additionalInfoEnabled: additionalInfoEnabled, eligibleForCancel: eligibleForCancel, eligibleForUploads: eligibleForUploads, eligibleForRedispute: eligibleForRedispute, fireCloseModal: fireCloseModal, handleUploadDocuments: handleUploadDocuments, onCancelDispute: onCancelDispute, handleRedispute: handleRedispute }) }, { children: [_jsx(ModalHeaderStrip, { title: merchantName, status: transactionStatus }), _jsxs(ModalContent, __assign({ "data-cy": "dispute-details-modal-content" }, { children: [_jsx(DisputeInfoUpperSection, { children: _jsx(DisputeInfoHeaderContent, { additionalInfoEnabled: additionalInfoEnabled, assetsURL: assetsURL, caseStatus: transactionStatus, eligibleForRedispute: eligibleForRedispute, handleLaunchChat: handleLaunchChat, handleRedispute: handleRedispute, handleUploadDocuments: handleUploadDocuments }) }), _jsxs(DisputeInfoLowerSection, { children: [_jsx(Stack, { size: "large" }), _jsx(DisputeTracker, {}), _jsx(Stack, { size: "large" }), docsRequested && (_jsxs(_Fragment, { children: [_jsx(DocumentsRequested, { disputeReason: disputeReason }), _jsx(Stack, { size: "large" })] })), disputeTabs ? _jsx(DisputeInfoTabs, {}) : _jsx(DisputeDetails, {})] })] }))] })));
};
export default DisputeInfo;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map